import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BreathingSleepExcellence from "./sections/BreathingSleepExcellence";
import OurClinicalFocus from "./sections/OurClinicalFocus";
import ThePracticeDrQayyum from "./sections/ThePracticeDrQayyum";
import ComprehensiveRespiratoryServices from "./sections/ComprehensiveRespiratoryServices";
import ThePathToBetterHealth from "./sections/ThePathToBetterHealth";
import ScheduleYourConsultation from "./sections/ScheduleYourConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BreathingSleepExcellence />
      <OurClinicalFocus />
      <ThePracticeDrQayyum />
      <ComprehensiveRespiratoryServices />
      <ThePathToBetterHealth />
      <ScheduleYourConsultation />
      <Footer />
    </div>;
}